export const HR_LETTERS = '/hr/Letters'

export const HR_LETTERS_SENT = `${HR_LETTERS}/sent`
export const HR_LETTERS_RECEIVED = `${HR_LETTERS}/received`
export const HR_LETTERS_SUMMARY = `${HR_LETTERS}/summary`
export const HR_LETTERS_ALLOWED_RECIPIENTS = `${HR_LETTERS}/allowed-recipients`

export function letterById(id: number) {
  return `${HR_LETTERS}/${id}`
}

export function letterOverview(id: number) {
  return `${HR_LETTERS}/${id}/overview`
}

export function letterRecipients(id: number) {
  return `${HR_LETTERS}/${id}/recipients`
}

export function letterReplies(id: number) {
  return `${HR_LETTERS}/${id}/replies`
}

export function letterForwards(id: number) {
  return `${HR_LETTERS}/${id}/forwards`
}

export function letterSend(id: number) {
  return `${HR_LETTERS}/${id}/send`
}

export function letterClose(id: number) {
  return `${HR_LETTERS}/${id}/close`
}

export function letterRead(id: number) {
  return `${HR_LETTERS}/${id}/read`
}

export function letterAttachments(id: number) {
  return `${HR_LETTERS}/${id}/attachments`
}

export function letterAttachmentById(letterId: number, attachmentId: number) {
  return `${HR_LETTERS}/${letterId}/attachments/${attachmentId}`
}
